import AllTab from './AllTab'
export default function All() {
  return <AllTab />
}
